import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import AjaxTab from "./tabs/AjaxTab";
import PropertiesTab from "./tabs/PropertiesTab";
import AjaxTableTab from "./tabs/AjaxTableTab";
import ImageTab from "./tabs/ImageTab";
import AjaxGalleryTab from "./tabs/AjaxGalleryTab";
import EchartTab from "./tabs/EchartTab";
import AjaxSliderTab from "./tabs/AjaxSliderTab";
import FormTab from "./tabs/FormTab";
import FeatureformTab from "./tabs/FeatureformTab";
import FeaturedeleteTab from "./tabs/FeaturedeleteTab";
import LinkListTab from "./tabs/LinkListTab";
import PoisTab from "./tabs/PoisTab";
import ComponentStatusTab from "./tabs/ComponentStatusTab";
import ComponentSubsTab from "./tabs/ComponentSubsTab";
import IfcTab from "./tabs/IfcTab";
import ComponentAddTab from "./tabs/ComponentAddTab";
import ComponentAttachmentsTab from "./tabs/ComponentAttachmentsTab";
import DocumentsTab from "./tabs/DocumentsTab";
import ErrorBoundary, {inlineErrorFallback} from "./ErrorBoundary";

class FeatureDetailsTab extends React.Component {

    static propTypes = {
        addTab: PropTypes.func,
        feature: PropTypes.object,
        labelUpdate: PropTypes.func,
        tab: PropTypes.object,
        visible: PropTypes.bool,
        windowId: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        visible: false,
        windowId: ''
    }

    createElement = () => {
        const components = {
            properties: PropertiesTab,
            ajax: AjaxTab,
            ajaxtable: AjaxTableTab,
            ajaxgallery: AjaxGalleryTab,
            ajaxslider: AjaxSliderTab,
            image: ImageTab,
            form: FormTab,
            featureform: FeatureformTab,
            featuredelete: FeaturedeleteTab,
            documents: DocumentsTab,
            echart: EchartTab,
            linklist: LinkListTab,
            pois: PoisTab,
            componentsubs: ComponentSubsTab,
            componentstatus: ComponentStatusTab,
            componentadd: ComponentAddTab,
            componentattachments: ComponentAttachmentsTab,
            ifc: IfcTab
        };
        if (typeof components[this.props.tab.view] !== "undefined") {
            // an error in a tab must not take down the window and the application
            return (
                <ErrorBoundary fallback={inlineErrorFallback} key={this.props.tab.id}
                    name={"Tab " + this.props.tab.view} resetKeys={[this.props.feature, this.props.tab.id]}>
                    {React.createElement(components[this.props.tab.view], {
                        key: this.props.tab.id,
                        feature: this.props.feature,
                        labelUpdate: this.props.labelUpdate,
                        addTab: this.props.addTab,
                        tab: this.props.tab,
                        windowId: this.props.windowId,
                        windowType: this.props.windowType
                    })}
                </ErrorBoundary>
            );
        }
        return React.createElement(
            () => <div>The tab view {this.props.tab.view} has not been created yet.</div>,
            {key: this.props.tab.id}
        );
    }

    render() {
        return (
            <>
                {this.props.visible ?
                    <div className="feature-details-tab">
                        {this.createElement()}
                    </div>
                    : null}
            </>
        );
    }
}

const selector = () => ({});

export default connect(selector, {})(FeatureDetailsTab);
